/* frontend/src/lib/taskSteps/inputfields/Date.svelte generated by Svelte v4.2.12 */
import { SvelteComponent, init, safe_not_equal } from "svelte/internal";

import "svelte/internal/disclose-version";

class Date extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, null, safe_not_equal, {});
	}
}

export default Date;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6IiIsIm5hbWVzIjpbXSwic291cmNlcyI6WyJEYXRlLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyIiXX0=